import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="section-title">About Us</h2>
            <p className="about-description">
              With 7+ experience in project development, we specialize in turning 
              complex ideas into successful, scalable projects. Our team of experts brings together 
              diverse skills in planning, design, development, and project management.
            </p>
            <p className="about-description">
              We pride ourselves on delivering exceptional results that exceed expectations. 
              Every project we undertake is approached with attention to detail, creative problem-solving, 
              and a commitment to excellence.
            </p>
            <div className="about-features">
              <div className="feature-item">
                <div className="feature-icon">✓</div>
                <span>Experienced & Professional Team</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">✓</div>
                <span>Custom Solutions for Every Need</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">✓</div>
                <span>Proven Track Record of Success</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">✓</div>
                <span>Client-Focused Approach</span>
              </div>
            </div>
          </div>
          <div className="about-visual">
            <div className="visual-card">
              <div className="visual-content">
                <h3>Why Choose Us?</h3>
                <ul className="benefits-list">
                  <li>✅ 100% Client Satisfaction</li>
                  <li>✅ On-Time Delivery</li>
                  <li>✅ Transparent Communication</li>
                  <li>✅ Competitive Pricing</li>
                  <li>✅ Ongoing Support</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
